import { render } from "./MessageInsert.vue?vue&type=template&id=68650bb6&scoped=true&ts=true&lang=pug"
import script from "./MessageInsert.vue?vue&type=script&lang=ts"
export * from "./MessageInsert.vue?vue&type=script&lang=ts"

import "./MessageInsert.vue?vue&type=style&index=0&id=68650bb6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68650bb6"]])

export default __exports__